import React, { useState, useCallback, useContext } from 'react';

import { postAssignDocument } from '../context/http';
import AssignAgentModal from 'modules/journey/AssignAgentModal/component';
import DocsContext from 'containers/Docs/context/DocsContext';

const t = {
  modalTitle: 'Assign document to agent',
  modalWarning:
    'Please be aware that all the documents belonging to this carrier will be assigned to the same agent.',
};

const DocsAssignModal = ({ show, docId, carrierId, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [agentSelected, setAgentSelected] = useState({});
  const { refreshTasks } = useContext(DocsContext);

  const handleAssignOwner = useCallback(async () => {
    setLoading(true);
    await postAssignDocument({
      docId: docId,
      carrier_uuid: carrierId,
      owner: agentSelected?.email,
    });
    refreshTasks();
    setLoading(false);
    onClose();
  }, [agentSelected, docId, carrierId, onClose, refreshTasks]);

  const handleSelectOwner = useCallback(async (val) => {
    const { agent } = val || {};
    setAgentSelected({ label: agent?.name, value: agent?.id, email: agent?.email });
  }, []);

  return (
    <AssignAgentModal
      title={t.modalTitle}
      show={show}
      selectedAgent={agentSelected}
      onAssign={handleAssignOwner}
      onSelect={handleSelectOwner}
      onClose={onClose}
      loading={loading}
      warning={t.modalWarning}
    />
  );
};

export default DocsAssignModal;
